import ABCyaPhaser from "@abcya/abcya_phaser";
import SoundAssetKeys from "../SoundAssetKeys";
import { dotPop } from "../Utilities";
import FractionTile from "./FractionTile";

export default class GridDisplay extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);

        this.delegate = scene;

        this.workingWidth = 720;
        this.workingHeight = 720;

        this.bg = null;
        this.tiles = null;
        this.clickable = true;

        this.bg = this.scene.add.graphics({ fillStyle: { color: 0x58afb6 } });
        this.bg.fillRoundedRect(0, 0, this.workingWidth, this.workingHeight, 6);
        this.bg.generateTexture("griddisplaybg", this.workingWidth, this.workingHeight);
        this.bg.destroy();
        this.bg = this.scene.add.image(0, 0, "griddisplaybg").setOrigin(0);
        this.add(this.bg);
    }

    displayPuzzle(spotMatrix)
    {
        let rowLen = spotMatrix.length;
        let colLen = 0;
        let padding = 4;
        let startX = 24;
        let startY = 24;

        let tweenWait = 0;
        let tweenTime = 0;
        this.tiles = [];
        let waits = [];

        for (let i = 0; i < 16; i++)
        {
            tweenWait += Phaser.Math.Between(120, 180);
            tweenTime = Math.max(tweenTime, tweenWait);
            waits.push(tweenWait);
        }
        Phaser.Utils.Array.Shuffle(waits);
        tweenWait = 0;

        let tweenType = Phaser.Math.Between(1, 100);

        for (let row = 0; row < rowLen; row++)
        {
            colLen = spotMatrix[row].length;
            for (let col = 0; col < colLen; col++)
            {
                let item = new FractionTile(this.scene);
                item.setValue(spotMatrix[row][col]);
                item.centerContainer();
                ABCyaPhaser.Container.setContainerInteractive(item, false);
                item.destX = item.x = startX + (item.workingWidth * row + padding * row + item.workingWidth / 2);
                item.destY = item.y = startY + (item.workingHeight * col + padding * col + item.workingHeight / 2);
                if (tweenType < 50)
                {
                    let x = (Phaser.Math.Between(1, 100) < 50) ? -(Phaser.Math.Between(150, 200)) : this.scene.scale.width + Phaser.Math.Between(100, 200);
                    let y = (Phaser.Math.Between(1, 100) < 50) ? -(Phaser.Math.Between(150, 200)) : 768 + Phaser.Math.Between(100, 200);
                    item.x = x;
                    item.y = y;
                    this.scene.time.delayedCall(waits[tweenWait], this.slideTileIn, [item], this);
                } else
                {
                    item.setScale(0);
                    this.scene.time.delayedCall(waits[tweenWait], this.bringTileIn, [item], this);
                }

                this.tiles.push(item);
                this.add(item);
                item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.tileClick(item));
                tweenWait++;
            }
        }
        return tweenTime;
    }

    bringTileIn(tile)
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pop, this.scene);
        dotPop(tile);
    }

    slideTileIn(tile)
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._swosh_in, this.scene);
        ABCyaPhaser.Tweens.addTween(tile, 360, { x: tile.destX, y: tile.destY }, Phaser.Math.Easing.Linear);
    }

    tileClick(sender)
    {
        this.delegate.tileClick(sender);
    }

    hold()
    {
        this.clickable = false;
        let len = this.tiles.length;
        for (let i = 0; i < len; i++)
        {
            if (this.tiles[i].active && !this.tiles[i].selected)
            {
                this.tiles[i].alpha = 0.4;
            }
        }
    }

    unhold()
    {
        this.clickable = true;
        let len = this.tiles.length;
        for (let i = 0; i < len; i++)
        {
            if (this.tiles[i].active && !this.tiles[i].selected)
            {
                this.tiles[i].alpha = 1.0;
            }
        }
    }

    showCorrect(tiles)
    {
        let len = tiles.length;
        for (let i = 0; i < len; i++)
        {
            tiles[i].showCorrect(true);
        }
        this.scene.time.delayedCall(320, this.gridCorrectWaitDone, null, this);
    }

    gridCorrectWaitDone()
    {
        this.delegate.showCorrectDisplay();
    }

    showIncorrect(tiles)
    {
        let len = tiles.length;
        let time = 200;
        for (let i = 0; i < len; i++)
        {
            tiles[i].showCorrect(false);
            this.scene.tweens.timeline({
                tweens: [
                    ABCyaPhaser.Tweens.createTween(tiles[i], time, { delay: 100, scale: 0.8 }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(tiles[i], time, { scale: 1, yoyo: true, repeat: 1 }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(tiles[i], time, { scale: 1 }, Phaser.Math.Easing.Linear),
                ]
            });
        }
        this.scene.time.delayedCall(time * 6 + 100, this.gridFeedbackDone, null, this);
    }

    gridFeedbackDone()
    {
        this.delegate.resetSelected();
    }

    strikeOutTransition()
    {
        let len = this.tiles.length;
        let wait = 0;
        for (let i = 0; i < len; i++)
        {
            wait = ((i % 4) - 3) * -1;
            let tile = this.tiles[i];
            tile.hideFraction();
            ABCyaPhaser.Tweens.addTween(tile, 940, { delay: 120 * wait, y: 768 + 140 }, Phaser.Math.Easing.Quadratic.In);
        }
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._crash, this.scene);
        return (120 * 3 + 940);
    }
}